import { logOmniClick } from 'omnitures';

/**
 * calculate and returns the active index for tabs
 * @author MMT8054
 * @param {Array} tabList
 * @param {String} pathname
 * @param {Boolean} pageRedirections
 * @return {Number}
 */
export const getActiveContentIndex = (tabList = [], pathname, pageRedirections) => {
	let key = getDetailConfigKey(pathname);

	const subKeys = key.split('-');
	const tab = subKeys[1];
	if (pageRedirections) {
		indexByKey(tabList, tab);
	}

	const length = tabList.length;
	for (let i = 0; i < length; i++) {
		const content = tabList[i];
		if (content?.active) {
			return i;
		}
	}
	return 0;
};

/**
 * Returns the active index based on active key
 * @param {Array} tabList
 * @author MMT8054
 * @param {String} key
 * @return  {Number}
 */
export const indexByKey = (tabList, key) => {
	const length = tabList.length;
	for (let i = 0; i < length; i++) {
		const content = tabList[i];
		if (content.tab.toLowerCase() === key?.toLowerCase()) {
			return i;
		}
	}
};

/**
 * create formatted json by adding span and class to have different colors for key and value
 * @author  MMT8054
 * @param {String} json
 * @return {String}
 */
export const syntaxHighlight = (json) => {
	json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function(match) {
		let cls = 'value';
		if (/^"/.test(match)) {
			if (/:$/.test(match)) {
				cls = 'key';
			} else {
				cls = 'value';
			}
		}
		return '<span class="' + cls + '">' + match + '</span>';
	});
};

/**
 * returns the key based on url path
 * @author  MMT8054
 * @param {String} pathname
 * @return {String}
 */
export const getDetailConfigKey = (pathname) => {
	const paths = pathname?.split('/');
	let key = paths?.[paths?.length - 1] || '';
	return key.toLowerCase();
};

/**
 * logs omnitures
 * @author  MMT8054
 * @param {String} trackEvent
 * @param {String} page
 * @param {String} pageName
 */
export const logOmniture = (trackEvent = '', page = '', pageName = '') => {
	logOmniClick(page, {
		prop54: trackEvent,
		pageName: pageName
	});
};
